import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Button, Container, Row, Col } from 'reactstrap'

import WhiteFooter from 'components/Footers/WhiteFooter.js'
import logoMural from 'assets/img/logo_mural_2.png'
import Loading from 'components/Loading/Loading'
import { StudentService } from 'services/student'
import { StudentsHelper } from 'helpers/students'
import ProgressBar from '../../components/ProgressBar/ProgressBar'
import Tabs from '../../components/Tabs/Tabs'
import PanelContext from 'contexts/Panel'
import StudentsTable2 from 'components/Table/StudentsTable2'

const ConsolidadoPage = ({ history }) => {
  const { year, semester, setYear, setSemester, years } = useContext(PanelContext)

  const [isLoading, setIsLoading] = useState(false)
  const [universityStudentsList, setUniversityStudentsList] = useState([])
  const [courseStudentsList, setCourseStudentsList] = useState([])
  const [classificationStudentsList, setClassificationStudentsList] = useState([])

  const goBack = useCallback(() => {
    history.push('/mural-aprovados-sisu')
  }, [history])

  useEffect(() => {
    const getConsolidateStudentsList = async () => {
      setIsLoading(true)
      try {
        const response = await StudentService.consolidate(year, semester)
        if (response.status === 200) {
          const university = StudentsHelper.formatList(response.data.AprovadosUniversidade)
          const course = StudentsHelper.formatList(response.data.AprovadosCurso)
          const classification = StudentsHelper.formatList(response.data.AlunosClassificacao)

          setUniversityStudentsList(university)
          setCourseStudentsList(course)
          setClassificationStudentsList(classification)
        }
      } catch (e) {
      } finally {
        setIsLoading(false)
      }
    }

    getConsolidateStudentsList()
  }, [year, semester])

  const handleYearChange = ({ target: { value } }) => {
    const [ year, semester ] = value.split('.')
    setYear(parseInt(year))
    setSemester(parseInt(semester))
  }

  return (
    <div className="section">
      <Container className="text-center">
        <Row>
          <Col className="d-flex justify-content-between align-items-center">
            <select
              id="select-year"
              className="form-select"
              aria-label="Selecione o ano"
              onChange={handleYearChange}
              style={{
                color: '#000',
                borderColor: '#aaa',
              }}
            >
              {years.map(item => (
                <option value={item.value} selected={item.value === `${year}.${semester}`}>{item.label}</option>
              ))}
            </select>

            <Button onClick={goBack} className="btn-round" color="#000">
              <span>X</span>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <img src={logoMural} style={{ width: 260 }} alt="" />
          </Col>
        </Row>
      </Container>

      <Container className="text-center">
        <h2
          className="title"
          style={{
            fontWeight: 600,
            letterSpacing: 2,
            marginTop: 30,
            fontSize: 32,
          }}
        >
          Resultados consolidados
        </h2>
        <br />
        <p
          className="description"
          style={{
            letterSpacing: 2,
            color: '#000',
            marginTop: -20,
            lineHeight: 1.6,
          }}
        >
          Nesta área, você analisa as aprovações dos seus estudantes por instituição de ensino, curso e posição. Você
          terá os dados consolidados para divulgar em toda a sua comunidade.
        </p>
      </Container>

      <br />
      <Tabs
        tabs={[
          {
            label: (
              <span>
                por <strong>universidade</strong>
              </span>
            ),
            component: (
              <div style={{ padding: '40px 0' }}>
                {universityStudentsList?.map((university, index) => (
                  <ProgressBar
                    key={index}
                    label={university.Nome}
                    percentage={university.Porcentagem}
                    total={university.Quantidade}
                    totalLabel="alunos"
                    progressColor={index === 0 ? '#E94B4B' : '#707070'}
                    externalLinkOnClick={() =>
                      history.push(`/resultados-consolidados-filtro?universidade=${university.Nome}`)
                    }
                  />
                ))}
              </div>
            ),
          },
          {
            label: (
              <span>
                por <strong>curso</strong>
              </span>
            ),
            component: (
              <div style={{ padding: '40px 0' }}>
                {courseStudentsList?.map((course, index) => (
                  <ProgressBar
                    key={index}
                    label={course.Nome}
                    percentage={course.Porcentagem}
                    total={course.Quantidade}
                    totalLabel="alunos"
                    progressColor={index === 0 ? '#E94B4B' : '#707070'}
                    externalLinkOnClick={() => history.push(`/resultados-consolidados-filtro?curso=${course.Nome}`)}
                  />
                ))}
              </div>
            ),
          },
          {
            label: (
              <span>
                por <strong>posição</strong>
              </span>
            ),
            component: (
              <div style={{ padding: '40px 0' }}>
                <Container className="text-center">
                  {isLoading ? (
                    <Loading />
                  ) : (
                    <StudentsTable2 students={classificationStudentsList} />
                  )}
                </Container>
              </div>
            ),
          },
        ]}
      />
      <br />
      <br />
      <br />

      <WhiteFooter />
    </div>
  )
}

export default ConsolidadoPage
